import { GramPostProps } from "../../../Components/TheGramApp/TheGramAppInterfaces";

import pic1 from "./TimeSquareTheGramAssets/Post1.webp";
import pic2 from "./TimeSquareTheGramAssets/Post2.webp";
import dp1 from "./TimeSquareTheGramAssets/pfp1 (1).png";
import dp2 from "./TimeSquareTheGramAssets/pfp2 (1).png";

export const TimeSquareTheGramContent: GramPostProps[] = [
  {
    Profile: { name: "@saramahkzoumi_95", image: dp1 },
    Date: "18 Aug 2024",
    Image: pic1,
    Likes: "2,444",
    Caption: "Best weekend with my sister in New York 😘 @bubblebear_nyc",
    Location: "",
  },
  {
    Profile: { name: "@mommy_zeneli", image: dp2 },
    Date: "18 Aug 2024",
    Image: pic2,
    Likes: "1,202",
    Caption: "my gorgeous issy and batman right before the terrible stampede!",
    Location: "",
  },
];
